import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import {
  IconButton, Modal, ModalBody, ModalHeader,
} from '@americanexpress/dls-react';
import { IconInfo } from '@americanexpress/dls-icons';
import { hasCountryOfResidenceDropdownTooltipRule } from '../../../constants/ruleConstants';

const CountryOfResidenceInfoModal = () => {
  const { formatMessage, messages: { countryOfResidencesList = [] } } = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const hasCountryOfResidenceDropdownTooltip = useConditionalFeature(
    hasCountryOfResidenceDropdownTooltipRule);
  const openModal = () => { setIsOpen(true); };
  const closeModal = () => { setIsOpen(false); };

  if (!hasCountryOfResidenceDropdownTooltip || countryOfResidencesList.length === 0) {
    return false;
  }

  return (
    <>
      <IconButton
        screenReaderLabel={formatMessage({ id: 'countryOfResidence.ariaLabel' })}
        shape="round"
        variant="tertiary"
        id="countryOfResidenceModalButton"
        onClick={openModal}
        reactlytics={{ element: 'countryOfResidenceModal' }}
      >
        <IconInfo style={{ width: '1rem' }} />
      </IconButton>
      {
        isOpen && (
          <Modal
            id="countryOfResidenceModal"
            aria-labelledby="countryOfResidenceModalButton"
            onClose={closeModal}
          >
            <ModalHeader>
              <h2>{formatMessage({ id: 'countryOfResidence.modal.title' })}</h2>
            </ModalHeader>
            <ModalBody>
              {formatMessage({ id: 'countryOfResidence.modal.body' })}
            </ModalBody>
          </Modal>
        )
      }
    </>
  );
};

export default CountryOfResidenceInfoModal;
